export const SEMAGLUTIDE_QUESTION_ORDER = [
  "4UHdlhvX",
  "bMXhyKPP",
  "hR83gZJN",
  "EeOHlZpn",
  "aZ3fQ7",
  "tW4dOg",
  "OL04JD",
  "ZciHgo",
  "bK7zQe",
  "Spz0cK",
  "8V4FaT",
  "Yp49Lm",
  "0MuseP",
  "NfClezlD",
  "q4KDV5x7",
];
export const TIRZEPATIDE_QUESTION_ORDER = [
  "4UHdlhvX",
  "bMXhyKPP",
  "hR83gZJN",
  "EeOHlZpn",
  "aZ3fQ7",
  "tW4dOg",
  "OL04JD",
  "ZciHgo",
  "bK7zQe",
  "Spz0cK",
  "8V4FaT",
  "Yp49Lm",
  "0MuseP",
  "NfClezlD",
  "q4KDV5x7",
];
export const METFORMIN_QUESTION_ORDER = [
  "4UHdlhvX",
  "bMXhyKPP",
  "hR83gZJN",
  "EeOHlZpn",
  "aZ3fQ7",
  "tW4dOg",
  "OL04JD",
  "ZciHgo",
  "bK7zQe",
  "Spz0cK",
  "8V4FaT",
  "Yp49Lm",
  "0MuseP",
];

export const FEMALE_HAIR_LOSS_QUESTION_ORDER = [
  "4UHdlhvX",
  "hR83gZJN",
  "ny616p",
  "bnglfo",
  "Spz0cK",
  "2G5sQR",
  "0MuseP",
  "c2vs7b",
];

export const ONDANSETRON_QUESTION_ORDER = [
  "BySfZPeb",
  "AwDlvnsF",
  "sclHYFp9",
  "1sLUdwjE",
  "Spz0cK",
  "zgyBNVOR",
  "0MuseP",
];

export const BIRTH_CONTROL_QUESTION_ORDER = [
  "4UHdlhvX",
  "irc6dp",
  "EeOHlZpn",
  "Myc9iHqT",
  "9RuYKFac",
  "ltuUgUVM",
  "DKUmkiFJ",
  "0m8mRILN",
  "lDLUzqzb",
  "Spz0cK",
  "RW7H2P5F",
  "EEm5q2oD",
  "0MuseP",
];

export const MALE_HAIR_LOSS_QUESTION_ORDER = [
  "4UHdlhvX",
  "irc6dp",
  "obDYqAwU",
  "5l1Bfiek",
  "fGWJXh4P",
  "Ahu3GTmT",
  "Spz0cK",
  "LXFt0zbD",
  "kkemoPLU",
  "0MuseP",
];

export const ED_QUESTION_ORDER = [
  "4UHdlhvX",
  "9octQt",
  "VSPsSHcN",
  "caixOrVe",
  "w93Dorb6",
  "Hq3If1Sj",
  "Spz0cK",
  "kkemoPLU",
  "0MuseP",
  "nBCju9Nf",
  "3QLobSYW",
];

export const AMH_QUESTION_ORDER = [
  "4UHdlhvX",
  "hR83gZJN",
  "7qZ9PHcj",
  "378iXD2C",
  "iBAYfoGF",
  "nNHnpiRo",
  "3kUTzSAT",
  "9hjsMc0L",
  "gXS7Yey5",
  "ilVnF0Zo",
  "TpR28CFZ",
  "SHPkXgl8",
  "5zocwFXS",
  "1VZWj30X",
  "S6bbohJs",
  "bN0Kvyxw",
  "sumPgpW8",
  "TiDfjbwR",
  "fp5Uaojn",
  "AXXzdXd9",
  "OJjO82Mm",
  "Spz0cK",
  "kkemoPLU",
  "0MuseP",
  "WH8Cb6OQ",
];

export const AA_QUESTION_ORDER = [
  "4UHdlhvX",
  "hR83gZJN",
  "4m0VUjcf",
  "TO3n2mZj",
  "Spz0cK",
  "kkemoPLU",
  "0MuseP",
  "prpg10",
];

export const AC_QUESTION_ORDER = [
  "4UHdlhvX",
  "hR83gZJN",
  "4m0VUjcf",
  "oOnocxUg",
  "X3Mo9VAq",
  "5u7EkmPv",
  "Spz0cK",
  "kkemoPLU",
  "0MuseP",
  "prpg10",
];

export const productQuestionsOrder: Record<string, string[]> = {
  st: SEMAGLUTIDE_QUESTION_ORDER,
  tr: TIRZEPATIDE_QUESTION_ORDER,
  mt: METFORMIN_QUESTION_ORDER,
  "st-ot": SEMAGLUTIDE_QUESTION_ORDER,
  "tr-ot": TIRZEPATIDE_QUESTION_ORDER,
  fhl: FEMALE_HAIR_LOSS_QUESTION_ORDER,
  on: ONDANSETRON_QUESTION_ORDER,
  bc: BIRTH_CONTROL_QUESTION_ORDER,
  "mhl-ot": MALE_HAIR_LOSS_QUESTION_ORDER,
  "fhl-ot": FEMALE_HAIR_LOSS_QUESTION_ORDER,
  "ed-ot": ED_QUESTION_ORDER,
  "amh-ot": AMH_QUESTION_ORDER,
  "aa-ot": AA_QUESTION_ORDER,
  "ac-ot": AC_QUESTION_ORDER,
};

export const QuestionTypes = {
  MULTI_CHOICE: "multiple_choice",
  SINGLE_CHOICE: "single_choice",
  TEXT: "text",
  NUMBER: "number",
  PROGRESS_PROJECTION: "progress-projection",
  HEIGHT_WEIGHT: "height_weight",
  BIRTHDAY: "birthday",
  GLP1_PRELIMINARY_RESULTS: "glp1_preliminary_results",
  GLP1_REVIEWS: "glp1_reviews",
  CANCELLATION_MESSAGE: "cancellation_message",
  CANCELLATION_REVIEW: "cancellation_review",
  MESSAGE_IMAGE: "message_image",
  ED_OPTIONS: "ed_options",
  MESSAGE: "message",
  SHIPPING_INFORMATION: "shipping-information",
  ID_VERIFICATION: "id-verification",
  PAYMENT_INFORMATION: "payment-information",
  PAYMENT_CONFIRMATION: "payment-confirmation",
  STATE_DISQUALIFICATION: "state-disqualification",
  PHARMACY_SEARCH: "pharmacy_search",
};
